module.exports = __webpack_public_path__ + "img/1.0dd0b5cb.jpg";